import React, { useState } from "react";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import {
  SORT_TYPE_DASHBOARD_PARAMS,
  useSortTypeDashboardStore,
} from "@/store/sortTypeDashboardStore";
import { SortType } from "@/types/referals";
import Modal from "@/ui/Modal/Modal";
import classNames from "classnames";
import { dataTrigger, type Trigger } from "@/analytics";
import cls from "./styles.module.scss";

interface SortingBlockProps {
  sortReferals: (elem: string) => Promise<void>;
}

const statusOptions: Record<SortType, string> = {
  max: "По максимальной выгоде",
  min: "По минимальной выгоде",
  new: "Сначала новые",
  old: "Сначала старые",
};
const sortTypes = Object.keys(statusOptions) as SortType[];

const SORT_TRIGGERS: Record<SortType, Trigger> = {
  max: "ref.sort.max_benefit",
  min: "ref.sort.min_benefit",
  new: "ref.sort.date_desc",
  old: "ref.sort.date_asc",
};

export const SortingBlockDashboard = ({ sortReferals }: SortingBlockProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const sortType = useSortTypeDashboardStore((s) => s.sortType);
  const setSortType = useSortTypeDashboardStore((s) => s.setSortType);

  const openModal = () => {
    setIsOpen(true);
  };

  const handleSortTypeSelect = (id: SortType) => {
    if (id === sortType) return;

    switch (id) {
      case "max":
        break;
      case "min":
        break;
      case "new":
        break;
      case "old":
        break;
      default:
        return;
    }

    sortReferals(SORT_TYPE_DASHBOARD_PARAMS[id]);
    setSortType(id);
    setIsOpen(false);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Typography variant="body3" className={cls.title}>
          Сортировка
        </Typography>

        {sortTypes.map((id) => {
          const name = statusOptions[id];
          const isCurrent = sortType === id;
          return (
            <FlexRow
              key={id}
              justifyContent="space-between"
              className={classNames(
                cls.option,
                isCurrent ? cls.activeOption : undefined
              )}
              role="button"
              {...dataTrigger(SORT_TRIGGERS[id])}
              onClick={() => {
                handleSortTypeSelect(id);
              }}
            >
              <Typography>{name}</Typography>

              <div
                className={classNames(
                  cls.point,
                  isCurrent ? cls.activePoint : undefined
                )}
              >
                {isCurrent && <div className={cls.dot} />}
              </div>
            </FlexRow>
          );
        })}
      </Modal>

      <FlexRow
        gap={4}
        className={cls.optionsSelect}
        onClick={openModal}
        role="button"
        {...dataTrigger("ref.sort.open")}
      >
        <Typography
          className={classNames(
            cls.label,
            isOpen ? cls.activeLabel : undefined
          )}
        >
          Сортировка <span>{statusOptions[sortType]}</span> ⇅
        </Typography>
      </FlexRow>
    </>
  );
};
